import "./contactInfo.css"

export function ContactInfo() {
    return (
        <div className="d-flex contact-info p-4 md-row lg-col">

            <div className="call-us-section pb-2">
                <div className="d-flex gap-3 align-items-center mb-3">
                    <div className="call-icon"></div>
                    <div className="contact-title">Call To Us</div>
                </div>

                <p>We are available 24/7, 7 days a week.</p>

                <p>Phone: +8801611112222</p>
            </div>

            <div className="write-us-section mt-4">
                <div className="d-flex gap-3 align-items-center mb-3">
                    <div className="mail-icon"></div>
                    <div className="contact-title">Write To Us</div>
                </div>

                <p>Fill out our form and we will contact you within 24 hours.</p>

                <p>Emails: customer@exclusive.com</p>

                <p>Emails: support@exclusive.com</p>
            </div>

        </div>
    )
}